import styles from './QuestionList.module.scss'
import {CellToQuestionMapping} from "@/utils/crossword";
import classNames from "classnames";
import {CrosswordDataType} from "@/types/crosswords";
import Button from "@/components/UI/Button/Button";
import Icon from "@/components/UI/Icon/Icon";
import EditClueModal from "@/components/Crossword/Admin/EditClueModal/EditClueModal";

type Props = {
  acrossQuestionMap: Record<string, string>,
  downQuestionMap: Record<string, string>,
  acrossWordMap: Record<string, string>,
  downWordMap: Record<string, string>,
  selectedCell?: {x: number, y: number},
  onCellSelected: (i: number, j: number) => void
  cellToQuestionMap: CellToQuestionMapping[][]
  onQuestionClick: (across: boolean, question: string) => void
  goingAcross: boolean
  crossword: CrosswordDataType
  isAdmin?: boolean
}

const QuestionList = ({acrossQuestionMap, downQuestionMap, selectedCell, onCellSelected, cellToQuestionMap, onQuestionClick, goingAcross, crossword, isAdmin, downWordMap, acrossWordMap}: Props) => {


  return (
    <div className={styles.questionContainer}>
      <div>
        <h3>Across</h3>
        <ul className={styles.list}>
          {Object.keys(acrossQuestionMap).sort((a,b) => Number(a) > Number(b) ? 1 : -1).map((questionNo, index)  => (
            <li
              key={questionNo}
              onClick={() => onQuestionClick(true, questionNo)}
              className={classNames(
                styles.entry,
                selectedCell && cellToQuestionMap[selectedCell.y][selectedCell.x].across === Number(questionNo) && goingAcross && styles.selected,
                selectedCell && cellToQuestionMap[selectedCell.y][selectedCell.x].across === Number(questionNo) && !goingAcross && styles.offSelected
              )}
            >
              {isAdmin && <EditClueModal crossword={crossword} clue={acrossQuestionMap[questionNo]} word={acrossWordMap[questionNo]} direction='across' index={index}/>}
              <span className={styles.number}>{questionNo}.</span>
              {acrossQuestionMap[questionNo] || <span className={styles.noClue}>No clue yet</span>}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3>Down</h3>
        <ul className={styles.list}>
          {Object.keys(downQuestionMap).sort((a,b) => Number(a) > Number(b) ? 1 : -1).map((questionNo, index) => (
            <li
              key={questionNo}
              onClick={() => onQuestionClick(false, questionNo)}
              className={classNames(
                styles.entry,
                selectedCell && cellToQuestionMap[selectedCell.y][selectedCell.x].down === Number(questionNo) && !goingAcross && styles.selected,
                selectedCell && cellToQuestionMap[selectedCell.y][selectedCell.x].down === Number(questionNo) && goingAcross && styles.offSelected
              )}
            >
              {isAdmin && <EditClueModal crossword={crossword} clue={downQuestionMap[questionNo]} word={downWordMap[questionNo]} direction="down" index={index}/>}
              <div className={styles.number}>{questionNo}.</div>
              <div>{downQuestionMap[questionNo] || <span className={styles.noClue}>No clue yet</span>}</div>
            </li>
          ))}
        </ul>

      </div>
    </div>
  )
}

export default QuestionList